import PropTypes from 'prop-types';

export default function FilterRule({ filter, onRemove = () => {} }) {
	return (
		// US784493 - needs to be here because for whatever reason with react the parent elements are lost
		// and ws-tracking no longer sees them
		<li className="hide-from-ws-tracking">
			&quot;{filter.key}&quot; {filter.condition} &quot;{filter.value}
			&quot;
			<button
				type="button"
				className="btn btn-sm p-2 ml-2"
				onClick={() => onRemove(filter)}
			>
				X
			</button>
		</li>
	);
}

FilterRule.propTypes = {
	filter: PropTypes.shape({
		key: PropTypes.string.isRequired,
		condition: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired
	}).isRequired,
	onRemove: PropTypes.func
};
